<div class="mybets-summary mybets-epcot">
    <ng-container *ngTemplateOutlet="labelValueTemplate; context: { label: stakeLabel, value: stakeValue }"></ng-container>
    <ng-container *ngTemplateOutlet="labelValueTemplate; context: { label: returnLabel, value: returnValue }"></ng-container>
</div>

<ng-template #labelValueTemplate let-label="label" let-value="value">
    <div class="mybets-summary_cell">
        <span class="label">{{ label() }}:</span> <span class="value">{{ value() }}</span>
    </div>
</ng-template>
